import axios from '../axios';
const END_POINT = '/medical-records/notify/legal-reference';

const getNotifications = (userId) => axios.get(`${END_POINT}/${userId}`);

export {
    getNotifications,
}
